module.exports = __webpack_public_path__ + "static/media/print.97d52810.svg";